import React from "react";
import {
  Dialog,
  DialogType,
  PrimaryButton,
  Spinner,
  TextField,
  SpinnerSize,
  DialogFooter,
  DefaultButton,
} from "@fluentui/react";

const dialogContentProps = {
  type: DialogType.normal,
  title: "Activity Description",
  subText: "Please enter a description for the drafting activity.",
};

const ActivityDescriptionDialog = ({ open, handleClose, handleSave, description, setDescription, saving }) => {
  return (
    <Dialog hidden={!open} onDismiss={handleClose} dialogContentProps={dialogContentProps}>
      <TextField value={description} onChange={(e) => setDescription(e.target.value)} />
      <DialogFooter>
        <PrimaryButton
          text={saving ? <Spinner size={SpinnerSize.medium} /> : "Save"}
          onClick={handleSave}
          disabled={!description.length}
        />
        <DefaultButton text="Cancel" disabled={saving} onClick={handleClose} />
      </DialogFooter>
    </Dialog>
  );
};

export default ActivityDescriptionDialog;
